import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService} from '../../_services/auth.service';
import { StorageService } from '../../_services/storage.service';
import { UserService} from '../../_services/user.service';

import { NotificationService} from '../../_services/notification.service';

import { ConfigService } from '../../_services/config.service';
import { Router } from '@angular/router';
import { SettingsService } from '../../_services/settings.service';
import { forkJoin, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { PASSWORD_CHANGE_REQUIRED, TokenDto } from '../../_services/auth.dto';
import { UserDto } from '../../_services/user.dto';
import { buildSsoLoginUrl, isSsoRedirectLooping, recordSsoRedirect } from '../../_helpers/sso-flow';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit{
  loginForm!: FormGroup;
  passwordRegex = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$';
  passwordValidator = Validators.pattern(this.passwordRegex);
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';

  isDisableForm = true;
  ssoRedirect = false;
  ssoLoopBlocked = false;

  constructor(
    private formBuilder: FormBuilder,
    private auth:AuthService,
    private router:Router,
    private storageService:StorageService,
    private userService:UserService,
    private notificationService:NotificationService,
    private configService: ConfigService,
    private settingsService: SettingsService

  ) { }

  ngOnInit() {
    const config = this.configService.getConfig();
    this.initialiserFormulaire();

    if (config.ssoStatus) {
      // Le formulaire classique n'a pas lieu d'être en SSO, y compris le temps de la redirection
      this.ssoRedirect = true;

      // Déjà connecté : inutile de refaire l'aller-retour Keycloak à chaque ouverture de l'app.
      // Un token expiré sera renouvelé ou, à défaut, nettoyé par l'intercepteur, qui ramène ici.
      if (this.storageService.isLoggedIn()) {
        this.router.navigateByUrl('/chat', { replaceUrl: true });
        return;
      }

      if (isSsoRedirectLooping()) {
        // Boucle détectée : on laisse la main à l'utilisateur au lieu de repartir vers Keycloak
        this.ssoLoopBlocked = true;
        return;
      }

      this.startSsoLogin();
    }
  }

  startSsoLogin() {
    const config = this.configService.getConfig();
    const redirectUri = `${window.location.protocol}//${window.location.host}`+ '/sso/connected';
    recordSsoRedirect();
    buildSsoLoginUrl(config, redirectUri).then((loginUrl) => {
      window.location.href = loginUrl;
    });
  }

  initialiserFormulaire() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', {
        validators: [Validators.required, Validators.minLength(6)],
        updateOn: 'change'
      }]
    });
  }

  checkForm(){
    if(this.loginForm.valid){
      this.isDisableForm = false;
    }
    else{
      this.isDisableForm = true;
    }
  }


login(): void {
  if (this.loginForm.invalid) {
    this.notificationService.addNotification({
      type: 'alert',
      message: 'Merci de compléter le formulaire de connexion',
    });
    return;
  }

  this.isLoginFailed = false;

  const username = this.loginForm.get('email')?.value;
  const password = this.loginForm.get('password')?.value;

  this.auth.login(username, password).pipe(
    tap((token: TokenDto) => {
      this.storageService.saveToken(token);
    }),
    switchMap(() =>
      forkJoin({
        user: this.userService.me(),
        settings: this.settingsService.loadSettings()
      })
    )
  ).subscribe({
    next: ({ user, settings }) => {
      this.storageService.saveInfoUser(user);

      this.notificationService.addNotification({
        type: 'success',
        message: 'Connexion SynthIA réussie',
      });

      if (user.refresh_password === 1) {
        this.router.navigateByUrl('/user');
        return;
      }

      if (user.agreement === 0) {
        this.router.navigateByUrl('/user/agreement');
        return;
      }

      this.router.navigateByUrl('/chat');
    },
    error: (err: any) => {
      if (err.status === 403 && err.error?.detail === PASSWORD_CHANGE_REQUIRED) {
        this.router.navigateByUrl('/first-login', { state: { username, password } });
        return;
      }

      this.isLoginFailed = true;
      this.loginForm.get('password')?.reset();

      if (err.status === 404) {
        this.notificationService.addNotification({
          type: 'alert',
          message: 'Nom d\'utilisateur ou mot de passe incorrect',
        });
      } else if (err.status === 423) {
        this.notificationService.addNotification({
          type: 'alert',
          message: 'Votre compte a été bloqué, merci de contacter un administrateur',
        });
      } else {
        this.notificationService.addNotification({
          type: 'alert',
          message: 'Une erreur est survenue lors de la connexion',
        });
      }
    }
  });
}
  userInfo(){
    this.userService.me().subscribe({
      next:(ev: UserDto) => {
        this.storageService.saveInfoUser(ev);
        if(ev.refresh_password === 1){
          this.router.navigateByUrl('/user')
        } else if(ev.agreement === 0){
          this.router.navigateByUrl('/user/agreement')
        }    
      },
      error: (err: { status: number; error: { message: string; }; }) => {
        console.error(err);
      }
    });
  }
}
